import React from "react";
import deepImg from "./deep-tissue-massage.jpg";   // SAME image

const DeepTissue = ({ setActiveSection }) => {
  return (
    <section className="bg-white text-gray-900">

      {/* ⭐  STYLE FULL-WIDTH HERO BANNER */}
      <div className="relative w-full h-[350px] md:h-[450px]">
        <img
          src={deepImg}
          alt="Deep Tissue Massage Banner"
          className="absolute inset-0 w-full h-full object-cover"
        />

        {/* Dark Glass Overlay */}
        <div className="absolute inset-0 bg-black/50 backdrop-blur-[1px]"></div>

        {/* Center Large Title */}
        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="text-4xl md:text-6xl font-bold text-white drop-shadow-lg tracking-wide">
            Deep Tissue Massage
          </h1>
        </div>

        {/* Bottom Left Name */}
        <div className="absolute bottom-0 left-0 bg-black/40 backdrop-blur-md w-full py-4 px-6">
          <h2 className="text-xl md:text-2xl font-semibold text-white">
            Deep Tissue Massage
          </h2>
        </div>

        {/* Bottom Right Breadcrumb */}
        <div className="absolute bottom-0 right-0 bg-black/40 backdrop-blur-md py-4 px-6 flex items-center gap-2 text-white">
          <button
            onClick={() => setActiveSection("home")}
            className="hover:text-amber-300 transition"
          >
            Home
          </button>
          <span>›</span>
          <span className="text-amber-300">Deep Tissue</span>
        </div>
      </div>

      {/* ⭐ MAIN PREMIUM CONTENT */}
      <div className="container mx-auto px-4 py-20">

        <div className="grid md:grid-cols-2 gap-14 items-center">

          {/* LEFT — Big Image */}
          <img
            src={deepImg}
            alt="Deep Tissue Treatment"
            className="rounded-2xl shadow-[0_10px_35px_rgba(0,0,0,0.3)] w-full h-[520px] object-cover border border-gray-200"
          />

          {/* RIGHT — Luxury Description Block */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-amber-900 leading-tight">
              Intense Relief for Muscle Tension & Deep Stress
            </h2>

            <p className="text-gray-700 leading-relaxed mb-4 text-lg">
              Deep Tissue Massage targets the deeper layers of muscle tension,
              making it perfect for chronic stiffness, knots, or long-term pain.
            </p>

            <p className="text-gray-700 leading-relaxed mb-4 text-lg">
              Our certified therapists use slow, firm pressure to release tight
              muscles and fascia, restoring mobility and improving blood flow.
            </p>

            <p className="text-gray-700 leading-relaxed mb-4 text-lg">
              This therapy is recommended for athletes, fitness users, or those
              experiencing back, neck, shoulder, or sciatic tension.
            </p>

            <p className="text-gray-700 leading-relaxed mb-4 text-lg">
              After your session, your body feels lighter, deeply relaxed,
              flexible, and more aligned. It enhances posture, reduces muscle
              stiffness, and promotes full-body wellness.
            </p>

            {/* Book Button */}
            <button
              onClick={() => setActiveSection("booking")}
              className="bg-amber-900 text-white px-12 py-4 rounded-lg text-lg 
                         hover:bg-amber-800 transition-all hover:scale-105 shadow-lg mt-6"
            >
              Book Now
            </button>
          </div>
        </div>

      </div>
    </section>
  );
};

export default DeepTissue;
